module.exports = __webpack_public_path__ + "img/led_in_switch.a234eb04.png";